import type { PropsWithChildren, ReactNode } from "react";
import { classNames } from "@app/utils/classNames";

type SectionHeaderProps = PropsWithChildren<{
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  className?: string;
}>;

export function SectionHeader({
  title,
  subtitle,
  actions,
  className,
  children,
}: SectionHeaderProps) {
  return (
    <div className={classNames("ui-section-header", className)}>
      <div style={{ display: "flex", flexDirection: "column", gap: "0.35rem" }}>
        <h3 className="ui-section-header__title">{title}</h3>
        {subtitle ? <span className="ui-section-header__subtitle">{subtitle}</span> : null}
        {children}
      </div>
      {actions ? <div className="ui-card__actions">{actions}</div> : null}
    </div>
  );
}

